import {Trans} from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {LearnMoreButton} from '../../../../../components/common/callToAction/learnMoreButton';
import {
  StyledTooltipBodyDiv,
  StyledTooltipContentDiv,
} from '../../../../../components/common/tooltips/complexTooltipContent';

/*
 * Props.
 */

interface RequiredTaggingEditorActiveTooltipProps {}

/*
 * Styles.
 */

const StyledLearnMoreButton = styled(LearnMoreButton)`
  display: block;
  width: fit-content;
  margin-top: 16px;
  margin: 0 0 0 auto;
`;

/*
 * Component.
 */

export const RequiredTaggingEditorActiveTooltip: React.FC<RequiredTaggingEditorActiveTooltipProps> = () => (
  <StyledTooltipContentDiv $maxWidth={240}>
    <StyledTooltipBodyDiv>
      <Trans id="required-tagging-editor-active-tooltip">Require Tag rules can&apos;t be disabled</Trans>
      <StyledLearnMoreButton
        helpPageUrl="https://help.front.com/t/60hgg0p/required-tagging#how-do-i-turn-off-the-rule"
        size={VisualSizesEnum.SMALL}
      />
    </StyledTooltipBodyDiv>
  </StyledTooltipContentDiv>
);
